import { render, staticRenderFns } from "./icon-mpg.vue?vue&type=template&id=79c60af7&"
import script from "./icon-mpg.vue?vue&type=script&lang=js&"
export * from "./icon-mpg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports